<template>
  <v-menu
    v-model="open"
    full-width
  >
    <template v-slot:activator="{ on }">
      <v-chip
        text-color="white"
        :color="color"
        class="item"
        :style="itemStyles"
        small
        v-on="on"
        :draggable="isDraggable"
        @dragstart="handleDragStart"
        @dragend="handleDragEnd"
      >
        <v-avatar class="scale" :color="scaleColor(item.scale)">
          {{ item.scale.charAt(0) }}
        </v-avatar>
        <div class="content">
          {{ item.name }} | {{ item.planned_processes }} | {{ item.planned_recipes }}
        </div>
      </v-chip>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat>
      <v-toolbar color="primary" dark>
        <v-btn @click="showItem({ edit: true })" v-if="isDraggable" icon>
          <v-icon>edit</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ item.name }} ({{ item.status.replace(/\_/g, '&nbsp;') }})
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title primary-title>
        <ul>
          <li>
            <b>Project name:</b>
            <em> {{ item.project.name }}</em>
          </li>
          <li>
            <b>Scheduled date:</b>
            <em v-if="item.scheduled_date_rng.from.value === item.scheduled_date_rng.to.value"> {{ item.scheduled_date_rng.from.value }}</em>
            <em v-else> {{ item.scheduled_date_rng.from.value }} - {{ item.scheduled_date_rng.to.value }}</em>
          </li>
          <li>
            <b>Planning date:</b>
            <em v-if="item.planning_date_rng.from.value === item.planning_date_rng.to.value"> {{ item.planning_date_rng.from.value }}</em>
            <em v-else> {{ item.planning_date_rng.from.value }} - {{ item.planning_date_rng.to.value }}</em>
          </li>
          <li>
            <b>Количество процессов:</b>
            <em> {{ item.planned_processes }}</em>
          </li>
          <li>
            <b>Количество рецептур:</b>
            <em> {{ item.planned_recipes }}</em>
          </li>
        </ul>
      </v-card-title>
      <v-card-actions>
        <v-container fluid grid-list-xl class="pt-0">
          <v-layout wrap align-top justify-end>
            <v-btn small color="error">
              Cancel
            </v-btn>
            <v-btn small @click="showItem()" color="warning">
              More
            </v-btn>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'dateItem',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      open: false,
      COLOR: {
        trial: 'primary',
        booking: 'grey',
      },
    };
  },
  computed: {
    color() {
      const { COLOR, item: { type } } = this;
      return COLOR[type];
    },
    isDraggable() {
      return ['ON_APPROVAL'].includes(this.item.status);
    },
    itemStyles() {
      const start = new Date(...this.item.scheduled_date_rng.from.value.split('-').map(v => +v));
      const end = new Date(...this.item.scheduled_date_rng.to.value.split('-').map(v => +v));
      const count = Math.abs(start.getDate() - end.getDate());
      return {
        opacity: this.isDraggable ? 1 : 0.6,
        width: `${ !count ? 40 : count * 50 + 50 - 10 }px`,
      };
    },
  },
  methods: {
    scaleColor(currentScale) {
      return this.SCALE.find(scale => scale.name === currentScale).color;
    },
    showItem({ edit = false } = {}) {
      const { item: { id, type } } = this;
      this.$router.push({
        name: this.allRoutes[type].children[`${ type }Detail`].name,
        params: edit ? {
          id,
          editMode: edit,
          from: this.$route.name,
        } : {
          id,
          from: this.$route.name,
        },
      });
    },
    handleDragEnd(event) {
      event.target.removeAttribute('style');
    },
    handleDragStart(event) {
      event.target.style.opacity = 0.3;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.setData('item', JSON.stringify({
        id: this.item.id,
        type: this.item.type,
        scheduledDate: this.item.scheduled_date_rng.from.value,
      }));
    },
  },
};
</script>
<style>
  .item {
    z-index: 1;
  }

  .item:hover {
    width: auto !important;
  }

  .item .scale {
    border: 1px solid white !important;
  }
</style>
